
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("G5VDb", function(module, exports) {
module.exports = JSON.parse("{}");

});


//# sourceMappingURL=en-US.2107ce55.js.map
